const Types = {
    CLEAR: '@recepcionar/CLEAR',
    SEARCH_REQUEST: '@recepcionar/SEARCH_REQUEST', 
    SEARCH_SUCCESS: '@recepcionar/SEARCH_SUCCESS', 
    SEARCH_FAILURE: '@recepcionar/SEARCH_FAILURE' 
};

export default Types;